import { render, staticRenderFns } from "./GameReportBody.vue?vue&type=template&id=121360d4&"
import script from "./GameReportBody.vue?vue&type=script&lang=ts&"
export * from "./GameReportBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports